module.exports = __webpack_public_path__ + "static/media/pkm-plg2.fe5db17a.jpg";